if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.customVariantPickerWidget = document.querySelector('product-info variant-picker-widget');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      var formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      this.formIdInputValue = this.form.querySelector('[name=id]').value;
      if (this.formIdInputValue.includes(',')) {
          formData.delete('id');
          formData.delete('quantity');
      } 

      if(this.customVariantPickerWidget) {
        const sellingPlanId = this.customVariantPickerWidget.dataset.sellingPlanId;
        if (sellingPlanId){
          formData.append('selling_plan', sellingPlanId);
        }
      }
      
      config.body = formData;

      this.skipCart = false;
      if (this.form.querySelector('[name=id]').dataset.skipCart && this.form.querySelector('[name=id]').dataset.skipCart === 'true') {
        this.skipCart = true;
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (this.skipCart) {
            window.location = "/checkout";
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

if (!customElements.get('variant-picker-widget')) {
  customElements.define('variant-picker-widget', class VariantPickerWidget extends HTMLElement {
    constructor() {
      super();
      this.radios = this.querySelectorAll('input[type=radio');
      this.priceBoards = {
        main: this.closest('product-info').querySelector('.product-page-price .price-item'),
        subscription: this.querySelector('.product-subscription-price .price-item'),
        onetime: this.querySelector('.product-page-price .price-item')
      }
      this.variantRadios = document.querySelector('variant-picker-widget variant-radios');
      setTimeout(() => {
        this.variantRadios.dispatchEvent(new Event('change'));
      })
      this.boxDiscountBoards = this.querySelectorAll('.box-discount-board');
      this.getVariantData();
      this.boxDiscountBoards.forEach((board, index) => {
        const originalPrice = this.variantData[index]?.price;
        const discount =  originalPrice - this.variantData[index]?.selling_plan_allocations?.[0]?.price;
        board.textContent = discount ? (discount / originalPrice) * 100 + "% OFF" : "";
      })
      this.getSellingPlan();
      this.planName = "subscription";
      if (!this.variantData) return;
      this.setupEventListeners();
      this.render();
    }

    setupEventListeners() {
      this.radios.forEach(radio => radio.addEventListener('change', this.onPlanChange.bind(this)));
    }

    onPlanChange(evt) {
      if (evt.target.name === "custom_selling_plan"){
        this.planName = evt.target.value;
        const optionDiv = evt.target.closest('.variant-picker-widget__option');
        optionDiv?.classList.add('selected');
      }
      this.render();
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }

    getCurrentVariant() {
      if (this.variantRadios) return this.variantRadios?.currentVariant;
    }

    getSellingPlan() {
      this.sellingPlan = this.variantData[0]?.selling_plan_allocations?.[0];
    }

    render() {      
      this.dataset.plan = this.planName;
      switch(this.planName) {
        case 'subscription': 
          this.dataset.sellingPlanId = this.sellingPlan.selling_plan_id;
          this.querySelector('.variant-picker-widget__onetime').classList.remove('selected');
          this.querySelector('.variant-picker-widget__subscription').classList.add('selected');
          break;
        case 'onetime':
          this.dataset.sellingPlanId = "";
          this.querySelector('.variant-picker-widget__subscription').classList.remove('selected');
          this.querySelector('.variant-picker-widget__onetime').classList.add('selected');
      }
      setTimeout(() => this.renderPrices());
    }

    formatCurrency(price) {
      return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD'
      }).format(price/100);
    }

    renderPrices() {
      const currentVariant = this.getCurrentVariant();
      if (currentVariant.selling_plan_allocations?.[0]?.price && this.priceBoards.subscription) {
        this.priceBoards.subscription.textContent = this.formatCurrency(currentVariant.selling_plan_allocations?.[0]?.price);
      }
      this.priceBoards.onetime.textContent = this.formatCurrency(currentVariant.price);
      switch(this.planName) {
        case 'subscription': 
          this.priceBoards.main.textContent = this.formatCurrency(currentVariant.selling_plan_allocations?.[0]?.price);
          break;
        case 'onetime':
        default:
          this.priceBoards.main.textContent = this.formatCurrency(currentVariant.price);
      }
    }
    
  })
}